package ru.villawonka.app

import ru.villawonka.app.platform.JsKeyboard
import ru.villawonka.app.platform.telegram.Telegram
import ru.villawonka.app.platform.JsLogger
import ru.villawonka.app.platform.JsPlatform
import ru.villawonka.app.platform.JsSentry
import ru.villawonka.app.platform.JsTelegram
import ru.villawonka.app.platform.Keyboard
import ru.villawonka.app.platform.Logger
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.platform.Sentry

actual fun getPlatform(): Platform = JsPlatform()

actual fun getTelegram(): Telegram? = JsTelegram()

actual fun getSentry(): Sentry? = JsSentry()

actual fun getLogger(): Logger? = JsLogger()

actual fun getKeyboard(): Keyboard? = JsKeyboard()